const config = {
    webBuildNumber: "1.0.2-16",
    backendApi: "https://guitar.studioamk.com/api",
    // backendApi: "https://gtadmin.studioamk.com/app/api",
    socketApi: "",
    mainLayoutPaddingX: 30,
    screenWidth: "414px",
    sideBar: {
        expandWidth: 279,
        collapseWidth: 60,
        homePageOffset: 85
    },
    mobileScreenWidth: "414px",
    footerHeight : 60,
    drawerWidth: "414px",
    termsAndConditionsLink: "https://guitar.studioamk.com/site/terms.html",
    privacyPolicyLink: "https://guitar.studioamk.com/site/privacy.html",
    guideLink: "https://guitar.studioamk.com/site/guide.html",
    videoHeight: Math.floor(window.innerHeight * ( 60 / 100 )),
    playstoreLink: `https://play.google.com/store/apps/details?id=com.studioamk.guitar`,
    webPushNoti: {
        apiKey: "AIzaSyBbpYYkc2_QqgpcSxv723zq_76Y3bKokcQ",
        authDomain: "guitar.studioamk.com",
        projectId: "guitar-dbfb1",
        storageBucket: "guitar-dbfb1.appspot.com",
        messagingSenderId: "279036595578",
        appId: "1:279036595578:android:f03a4c67956bf228f4dac3"
    },
    tiktok: {
        clientKey: "awqr9o0nmj2iscig",
        nativeRedirectUri: "https://guitar.studioamk.com",
        webRedirectUri: "https://guitar.studioamk.com/tiktokCallback/",
        webAuthEndpoint: "https://www.tiktok.com/v2/auth/authorize/"
    },
    google: {
        clientKey: "279036595578-3teqlksb3migb9t66dvlf9jmmju51skt.apps.googleusercontent.com",
        adMobAppId: "ca-app-pub-4674378923969357~4630516391",
        adMobInterstitialAdId: "ca-app-pub-4674378923969357/5014493921",
        adMobBannerAdId: "ca-app-pub-4674378923969357/2855170808"
    },
    facebook: {
        appId: "236520296473409",
        interstitialPlacementId: "576905274864489_641800188374997",
        bannerPlacementId: "497375973266663_501784346159159",
    },
    color: {
        primaryColor: "#2D333B",
        secondaryColor: "#8054DB",
        sideBarColor: "#22272E",
        mainColor: "#1C2128",
        footerBgColor: "#1F1F1F",
        pageSelectedColor: "grey",
        pageNameColor: "#474747",
        htmlColor: '#1A1A1A'
    }
}
export default config ;